import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { getCategoryTitle } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { getFullAddress } from '../../../../helpers/address.helper';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';

@Component({
    selector: 'property-summary-page-property-information-section',
    templateUrl: './summary-page-property-information-section.component.html',
    styleUrls: ['./summary-page-property-information-section.component.scss']
})
export class ResidentialForSaleSummaryPagePropertyInformationSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    category: string;
    address: string;
    bedrooms: string;
    bathrooms: string;
    floorArea: string;
    landArea: string;
    toilets: string;
    ensuites: string;
    lounges: string;
    studies: string;
    homeAndIncome: string;
    garageParking: string;
    offStreetParking: string;
    parkingDetails: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.category = getCategoryTitle(this.categoryId);

            this.address = getFullAddress(
                this.draftData.propertyInformation,
                this.metadata.regions
            );

            if (this.draftData.propertyInformation.bedrooms === 6) {
                this.bedrooms =
                    this.draftData.propertyInformation.bedrooms + '+';
            } else if (this.draftData.propertyInformation.bedrooms === 0) {
                this.bedrooms = this.metadata.bedrooms.find(x => x.value === 0).display;
            }else {
                this.bedrooms = this.draftData.propertyInformation.bedrooms;
            }
            this.bathrooms = this.attributeValueForDisplay('bathrooms');
            this.floorArea = this.draftData.propertyInformation.floorArea
                ? this.draftData.propertyInformation.floorArea.toLocaleString() + 'm²'
                : '';
            this.landArea = this.draftData.propertyInformation.landArea || this.draftData.propertyInformation.landArea === 0
                ? this.draftData.propertyInformation.landArea.toLocaleString() + 'm²'
                : '';
            this.toilets = this.attributeValueForDisplay('toilets');
            this.ensuites = this.attributeValueForDisplay('ensuites');
            this.lounges = this.attributeValueForDisplay('lounges');
            this.studies = this.attributeValueForDisplay('studies');

            switch (this.draftData.propertyInformation.homeAndIncome) {
                case 1:
                    this.homeAndIncome = 'Yes';
                    break;
                case 0:
                    this.homeAndIncome = 'No';
                    break;
                default:
                    this.homeAndIncome = '-';
                    break;
            }
            this.garageParking = this.attributeValueForDisplay('garageParking');
            this.offStreetParking = this.attributeValueForDisplay('offStreetParking');
            this.parkingDetails = this.draftData.propertyInformation.parkingDetails;

            this._changeDetectorRef.markForCheck();
        });
    }

    private attributeValueForDisplay(key: string): string {
        if (this.draftData.propertyInformation[key] === 6) {
            return this.draftData.propertyInformation[key] + '+';
        } else {
            return this.offStreetParking = this.draftData.propertyInformation[key];
        }
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
